// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyB1C7I6RAmbwV4jrrRX7pm9-p3opivply4',
    authDomain: 'patent-search-e467a.firebaseapp.com',
    databaseURL: 'https://patent-search-e467a.firebaseio.com',
    projectId: 'patent-search-e467a',
    storageBucket: 'patent-search-e467a.appspot.com',
    messagingSenderId: '768741471497',
    appId: '1:768741471497:web:8942927f3f10ef0c'
  },
  version: '6.1.01'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
